import * as React from "react";
import { CommonInsightsReportHelp } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonInsightViews";
import { CommonInsightsDeploymentLeadTimeOverview, CommonInsightsDeploymentLeadTimeTopics } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonInsightsDeploymentLeadTimeViews";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration } from "../../../Registry/pageHelpRegistry";
export const InsightsReportDeploymentLeadTimeRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.insights.report.leadTime,
    renderOverview: (props) => (<>
            <CommonInsightsDeploymentLeadTimeOverview /> <CommonInsightsReportHelp />
        </>),
    renderTopics: (props) => <CommonInsightsDeploymentLeadTimeTopics />,
};
